export function initTheme() {
  const savedTheme = localStorage.getItem('theme') || 'dark';
  document.body.dataset.theme = savedTheme;

  // Login page: checkbox toggle
  const themeCheckbox = document.getElementById('themeCheckbox');
  if (themeCheckbox) {
    themeCheckbox.checked = savedTheme === 'dark';
    themeCheckbox.addEventListener('change', () => {
      const isDark = themeCheckbox.checked;
      document.body.dataset.theme = isDark ? 'dark' : 'light';
      localStorage.setItem('theme', document.body.dataset.theme);
    });
  }

  // Dashboard: icon button toggle
  const themeBtn = document.getElementById('themeToggleBtn');
  if (themeBtn) {
    themeBtn.addEventListener('click', () => {
      const current = document.body.dataset.theme;
      const next = current === 'dark' ? 'light' : 'dark';

      document.body.dataset.theme = next;
      localStorage.setItem('theme', next);

      // Small click feedback (legacy UX)
      themeBtn.style.transform = 'scale(0.9)';
      setTimeout(() => {
        themeBtn.style.transform = '';
      }, 150);
    });
  }
}

